import SendBoxx from "../Tools/SendBoox";

function ManageBroadcasts({ toggleRightBar }) {
  return (
    
    <div className="container-fluid">
      <div className="d-flex justify-content-between bg-white mb-5">
        <div className="d-flex justify-content-start al ign-items-center">
          <button
            type="button"
            className="btn-close m-3"
            onClick={toggleRightBar}
          ></button>
          <div className="fs-2 text-dark fw-bold">Telegram BroadCast</div>
        </div>
      </div>
      <SendBoxx />
    </div>
  );
}

export default ManageBroadcasts;
